import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useTranslation } from 'react-i18next';

const SubscriptionUnavailable = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 6, md: 10 } }}>
      <Paper
        elevation={0}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 3,
          p: { xs: 3, md: 5 },
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            mx: 'auto',
            mb: 3,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'action.hover',
            color: 'text.secondary',
          }}
        >
          <LockOutlinedIcon fontSize="large" />
        </Box>
        <Typography component="h1" variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
          {t('pro_subscription.ios_access_unavailable_title')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('pro_subscription.ios_access_unavailable_body')}
        </Typography>
      </Paper>
    </Container>
  );
};

export default SubscriptionUnavailable;
